const data = [
  {
    id: 0,
    title: 'Iphone 12',
    description:
      'iPhone 12 and iPhone 12 mini are splash, water, and dust resistant and were tested under controlled laboratory conditions with a rating of IP68 under IEC standard 60529 (maximum depth of 6 meters up to 30 minutes). Splash, water, and dust resistance are not permanent conditions. Resistance might decrease as a result of normal wear. ',
    image:
      'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.R943rmLZg-e7EB1H616eVAHaHa%26pid%3DApi&f=1',
    arImage: 'https://holonext.com/wp-content/uploads/2021/07/iphone.jpg',
    sceneId: '60abf6947eb9a4003801f8f6',
  },
  {
    id: 1,
    title: 'Apple watch',
    description:
      'Apple Watch is a line of smartwatches produced by Apple Inc. It incorporates fitness tracking, health-oriented capabilities, and wireless telecommunication, and integrates with iOS and other Apple products and services.',
    image:
      'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fmedia.istockphoto.com%2Fphotos%2Fapple-watch-sport-picture-id481616102%3Fk%3D6%26m%3D481616102%26s%3D170667a%26w%3D0%26h%3DL2rOg4lSkn_7w1jsfTgwgbbfNhaNDEkuXeT0QzTADYk%3D&f=1&nofb=1',
    arImage: 'https://holonext.com/wp-content/uploads/2021/07/apple_watch.jpg',
    sceneId: '60abf5ed7eb9a4003801f8eb',
  },
  {
    id: 2,
    title: 'Apple AirPods',
    description:
      'AirPods can be used as Bluetooth headphones with Apple devices using earlier software and with non-Apple devices, but functionality is limited.',
    image:
      'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.sharafdg.com%2Fcdn-cgi%2Fimage%2Fwidth%3D600%2Cheight%3D600%2Cfit%3Dpad%2Fassets%2F1%2F5%2Fb%2F7%2F15b7a39dfe44146cf1226cd4198b083ada94b37f_Airpod.jpg&f=1&nofb=1',
    arImage: 'https://holonext.com/wp-content/uploads/2021/07/apple_airpod.jpg',
    sceneId: '60abf9567eb9a4003801f901',
  },
  {
    id: 3,
    title: 'JBL GO3',
    description:
      'JBL Go 3 is IP67 waterproof and dustproof, so you can bring your speaker anywhere. Wireless Bluetooth streaming Wirelessly stream music from your phone, tablet, or any other Bluetooth-enabled device. 5 hours of playtime Don`t sweat the small stuff like charging your battery. Go 3 gives you up to 5 hours of playtime on a single charge.',
    image:
      'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.iwant.cz%2Fpic%2F18GU400301-400-400.jpg&f=1&nofb=1',
    arImage: 'https://holonext.com/wp-content/uploads/2021/07/1.jpg',
    sceneId: '60abf61e7eb9a4003801f8ef',
  },
  {
    id: 4,
    title: 'Beko Tv',
    description:
      '4K Beko TV with 4K Ultra HD4 quadruple image experience!With 4K UHD TV with 4X more pixels than FHD TV, you can see even the smallest details in each scene. 4K UHD TVs deliver a high-resolution, seamless, true-to-life viewing experience. HDR great visual experience awaits you!',
    image:
      'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse4.mm.bing.net%2Fth%3Fid%3DOIP.CeYkODxjq4TBRDFYZqSaBgHaE8%26pid%3DApi&f=1',
    arImage: 'https://holonext.com/wp-content/uploads/2021/07/400c.jpg',
    sceneId: '60abfc007eb9a4003801f932',
  },
  {
    id: 5,
    title: 'Samsung TabA7',
    description:
      'Galaxy Tab A7`s fast processor and upgraded memory⁴ mean you can do more of what you love—streaming, browsing, multitasking—more efficiently than ever before. Choose 32GB or 64GB of built-in storage and expand it up to 1TB with a microSD card.⁵ Delete less and keep more of the videos, photos and songs you love. ',
    image:
      'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.viettablet.com%2Fimages%2Fdetailed%2F46%2Fsamsung-galaxy-tab-a7-2020.png&f=1&nofb=1',
    arImage: 'https://holonext.com/wp-content/uploads/2021/07/tablepc.jpg',
    sceneId: '60abfc537eb9a4003801f939',
  },
];

export default data;
